import * as types from "../constants/ActionTypes";

const initialState = {
  defaultFilter: null,
  canais: {},
  subservico: {},
  status: {},
  storageMedia: [],
  storageStatus: [],
  storageSubservice: [],
  isToBlockEdition: false,
};

const filtrosDeFila = (state = initialState, action) => {
  switch (action.type) {
    case types.ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA:
      if (!Boolean(action.filtersInDb)) return initialState;
      if (Boolean(action.defaultFilter)) {
        return {
          ...action.filtersInDb,
          defaultFilter: action.defaultFilter || null,
          canais: action.canais || {},
          subservico: action.subservico || {},
          status: action.status || {},
          storageMedia: action.storageMedia || [],
          storageStatus: action.storageStatus || [],
          storageSubservice: action.storageSubservice || [],
          isToBlockEdition: action.isToBlockEdition || false,
        };
      }

      return {
        ...action.filtersInDb,
        canais: action.canais || {},
        subservico: action.subservico || {},
        status: action.status || {},
        storageMedia: action.storageMedia || [],
        storageStatus: action.storageStatus || [],
        storageSubservice: action.storageSubservice || [],
        isToBlockEdition: action.isToBlockEdition || false,
      };

    default:
      return state;
  }
};

export default filtrosDeFila;
